import React, { useEffect } from 'react'
import { Modal, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import strings from "../../../utils/property-file/employeeData.json"

function SynchroniseConfirmationModal({isSynchronise,handleCancel,handleConfirm}) {


  useEffect(() => {
  if (isSynchronise) {
    const modalContent = document.querySelector(".skip-checkout-dialog .modal-content");
    if (modalContent) {
      modalContent.classList.add("modal-content-checkout");
    }
  }
}, [isSynchronise]);

  return (
   <Modal show={isSynchronise} onHide={handleCancel} size="sm" centered dialogClassName="skip-checkout-dialog">
      <Modal.Header>
            <p className="heading-text">
              {strings.synchroniseConfirmationHeading}
            </p>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center flex-column align-items-center ">
          <div>{strings.synchroniseConfirmationMsg}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          {strings.cancelbtn}
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          {strings.okbtn}
        </Button>
      </Modal.Footer>

    </Modal>
  )
}

SynchroniseConfirmationModal.propTypes = {
  isSynchronise: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
};

export default SynchroniseConfirmationModal